function hexToRGBA(hex, alpha) {
  if (!hex || !/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    return null; // Invalid hex color format
  }
  var c = null;
  var clampedAlpha = Math.max(0, Math.min(1, alpha)); // Clamp alpha value to the range [0, 1]

  if (hex.length === 4) {
    var _hex$match$map, _hex$match;
    // Convert 3-digit hex to 6-digit hex
    c = (_hex$match$map = (_hex$match = hex.match(/[A-Fa-f0-9]/g)) === null || _hex$match === void 0 ? void 0 : _hex$match.map(function (_char) {
      return parseInt(_char + _char, 16);
    })) !== null && _hex$match$map !== void 0 ? _hex$match$map : null;
  } else if (hex.length === 7) {
    var _hex$match$map2, _hex$match2;
    // Convert 6-digit hex to RGB
    c = (_hex$match$map2 = (_hex$match2 = hex.match(/[A-Fa-f0-9]{2}/g)) === null || _hex$match2 === void 0 ? void 0 : _hex$match2.map(function (_char2) {
      return parseInt(_char2, 16);
    })) !== null && _hex$match$map2 !== void 0 ? _hex$match$map2 : null;
  }
  if (c && c.length === 3) {
    return "rgba(".concat(c[0], ", ").concat(c[1], ", ").concat(c[2], ", ").concat(clampedAlpha, ")");
  }
  return null; // Invalid hex color format
}
export default hexToRGBA;